import React, { useEffect, useState } from 'react';
import ModalButton from './Buttons/normal/ModalButton';
import ModalContainer from './ModalContainer';
import { Box, Stack, Typography } from '@mui/material';
import Colors from '../../colors';
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import { toTitleCase } from '../../utils/helpers';
function InstructorsModal({ isVisible, setIsVisible, mainActionHandler, title, initialInstructors }) {
    const [instructorsList, setInstructorsList] = useState([]);
    const [currentInstructorInput, setCurrentInstructorInput] = useState('');
    const [error, setError] = useState(false);

    useEffect(() => {
        if (initialInstructors) {
            setInstructorsList(initialInstructors);
        }
    }, [initialInstructors, isVisible]);



    const removeInstructor = (name) => {
        setInstructorsList(prev => prev.filter(instructor => instructor !== name));
    };

    const addNewInstructor = () => {
        if (currentInstructorInput.trim().length === 0) {
            setError(true);
            setTimeout(() => {
                setError(false);
            }, 2000)
        } else {
            setInstructorsList([...instructorsList, toTitleCase(currentInstructorInput)]);
            setCurrentInstructorInput('');
        }
    };

    const handleMainAction = () => {
        mainActionHandler(instructorsList);
        setIsVisible(false);
    }

    const styles = {
        instructorBox: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: '8px',
            height: '51px',
            borderRadius: '8px',
            paddingLeft: '8px',
            border: '1px solid var(--green)',
            boxShadow: '0px 4px 15px rgba(62, 164, 72, 0.1)'
        },
        customInputBox: {
            height: '51px',
            padding: '5px',
            backgroundColor: Colors.white,
        },
        customInput: {
            border: error ? '2px solid red' : Colors.white,
            width: '100%',
            height: '41px',
            fontFamily: 'Jost',
            fontSize: '1.1rem',
            marginRight: '6px',
        },
        addNewInstructorButtonContainer: {
            marginLeft: 'auto',
            display: 'flex',
            borderRadius: '50%',
            background: Colors.green,
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px'
        },
        deleteButtonContainer: {
            marginLeft: 'auto',
            marginRight: '4px',
            display: 'flex',
            borderRadius: '50%',
            boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
        },
        buttonStyles: {
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            gap: '15px',
        }
    };

    return (
        <ModalContainer isVisible={isVisible}
            setIsVisible={setIsVisible}
            title={title} >
            <Stack sx={{
                width: '95%',
                marginTop: '5px',
                maxHeight: '300px',  // Set a fixed height
                overflowY: 'auto',  // Enable vertical scrolling
            }}>

                {instructorsList.map((name) => (
                    <Box
                        key={name}
                        sx={styles.instructorBox} >
                        <Typography sx={{ fontSize: '1.1rem', fontFamily: 'Jost' }}>
                            {name}
                        </Typography>
                        <Box
                            onClick={() => removeInstructor(name)}
                            sx={styles.deleteButtonContainer} >
                            <CancelIcon
                                sx={{ fontSize: 32, color: Colors.red }} />
                        </Box>
                    </Box>
                ))}
                <Box
                    sx={{ ...styles.customInputBox, ...styles.instructorBox }} >
                    <input
                        style={styles.customInput}
                        type="text"
                        placeholder={"Enter Instructor's name"}
                        value={currentInstructorInput}
                        onChange={(e) => setCurrentInstructorInput(e.target.value)} />
                    <Box
                        onClick={addNewInstructor}
                        sx={styles.addNewInstructorButtonContainer} >
                        <AddIcon
                            sx={{ fontSize: 28, color: Colors.white }} />
                    </Box>
                </Box>
            </Stack>


            <div style={styles.buttonStyles}>
                <ModalButton
                    color={Colors.green}
                    onClick={handleMainAction}>
                    Save
                </ModalButton>
                <ModalButton
                    color={Colors.gray}
                    onClick={() => setIsVisible(false)}>
                    Cancel
                </ModalButton>
            </div>
        </ModalContainer>
    )
}

export default InstructorsModal;